import Vue from 'vue'
import Router from 'vue-router'
import KickstarterPage from '@/components/KickstarterPage'
import ShopPage from '@/components/ShopPage'
import HomePage from '@/components/HomePage'
import AboutPage from '@/components/AboutPage'
import FAQPage from '@/components/FAQPage'
import ContactPage from '@/components/ContactPage'
import Launch4321Page from '@/components/Launch4321Page'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/kickstarter',
      name: 'KickstarterPage',
      component: KickstarterPage
    },
    {
      path: '/about',
      name: 'AboutPage',
      component: AboutPage
    },
    {
      path: '/faq',
      name: 'FAQPage',
      component: FAQPage
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage
    },
    {
      path: '/shop',
      name: 'ShopPage',
      component: ShopPage
    },
    {
      path: '/launch4321',
      name: 'Launch4321Page',
      component: Launch4321Page
    },
    {
      path: '',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '*',
      name: 'HomePage',
      component: HomePage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js